import ProgressBar from 'primevue/progressbar';

export default ProgressBar;
